import { DateTime } from "luxon";

export function FormattedDateTime(dateTime) {
  return `
    ${DateTime.fromISO(dateTime).toLocaleString({
      day: "2-digit",
      month: "long",
      year: "numeric",
    })} 
       at 
      ${DateTime.fromISO(dateTime).toLocaleString({
        hour: "numeric",
        minute: "numeric",
      })}`;
}
